import React from 'react';
import { Image, StyleSheet, View } from 'react-native';

import { Theme } from '@constants';

import sunnyDayWhite from '../../assets/icons/animated/sunnydaywhite.gif';
import sadCloud from '../../assets/sad_cloud.png';
import { isAndroid, isTizen, isWeb } from '../../helpers/Platform';
import { TWCText } from '../primitives/TWCText/TWCText';

export const VideoLoadingIndicator = ({ width, height, translation, hasError, message }) => {
  const offset = translation ?? { x: 0, y: 0 };

  if ((!width || !height) && isAndroid) {
    return <View style={styles.background} />;
  }

  return (
    <View style={[styles.background, { width, height, left: offset.x, top: offset.y }]}>
      <Image resizeMode={'contain'} source={hasError ? sadCloud : sunnyDayWhite} style={styles.sunImage} />
      {message && width === Theme.appWidth && (
        <TWCText style={styles.messageText} testID={'video_error_message'} variant={'regularText36Transparent'}>
          {message}
        </TWCText>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  background: {
    alignItems: 'center',
    elevation: 500,
    justifyContent: 'center',
    left: 0,
    position: isWeb && !isTizen ? 'fixed' : 'absolute',
    top: 0,
    zIndex: 500,
  },
  messageText: {
    padding: Theme.px(40),
  },
  sunImage: {
    height: Theme.px(100),
    width: Theme.px(100),
  },
});
